/**
 * Handle Language switcher
 *
 * When we use the language switcher in the header on an other page then the homepage, for example a PDP or collection page, 
 * the submit button should be redirected to that counterpart of the linked store.
 * We use the rendered alternate links from the Multi Store Hreflang Tags app to find the right counter part.
 */

// get language switcher and its dropdown options
const languageSwitcher = document.querySelectorAll('[data-language-switcher]'); 
const languageSwitcherOptions = document.querySelectorAll('[data-language-switcher-link]');

// listen for click on dropdown option
languageSwitcherOptions.forEach(option => {
  option.addEventListener('click', (e) => {
    e.preventDefault();

    if (!e.currentTarget.href) {
      return false;      
    }

    // check if we have a counterPartUrl otherwise fallback to the original href (=homepage)
    let urlToOpen = e.currentTarget.href;
    const newUrl = getCounterPartUrl(removeProtocol(urlToOpen));
    if (newUrl) {
      urlToOpen = newUrl;
    }
    // add current url attributes
    urlToOpen = urlToOpen + location.search;

    // open link
    window.location.href = urlToOpen;

  });
});

/**
 * removeProtocol
 * @description Remove http or https from url
 */
function removeProtocol(url) {
  if (!url) {
    return false;
  }
  const domain = (new URL(url));
  if (!domain.host) {
    return false;
  }
  return domain.host;
}

/**
 * getCounterPartUrl
 * @description Find the right counter part by using the alternate links that the app Multi Store Hreflang renders.
 */
function getCounterPartUrl(url) {

  if (!url) {
    return false;
  }

  // Find the store to link to. Store item contains the primary domain and myshopify domain.
  // The reason why we need to find the domain and shopify domain is because  Multi Store Hreflang sometimes outputs the primary domain and sometimes the myshopify domain.
  const stores = languageSwitcher[0].dataset.stores || false;
  const storesArray = stores?.split(',');
  if ( storesArray.length === 0) {
    return false;
  }
  let storeToLinkTo = null;
  storesArray.forEach(function(store){
    let storeArr = store.split('|');
    if (storeArr[1] == url) {
      storeToLinkTo = store;
    }
  });
  
  // get counterPartLink 
  const alternateLinksArray = [...document.querySelectorAll('link[rel="alternate"]')];
  if (alternateLinksArray.length === 0) {
    return false;
  }

  // get counterPartLink and return value
  let counterPartLink = null;
  alternateLinksArray.forEach(function(alternateLink){
    let href = alternateLink.href;
    let store_url = storeToLinkTo.split('|');
    if (alternateLink.type.length == 0) {
      if (href.indexOf(store_url[1]) > -1) {
        counterPartLink = href;
      }
    }
  });
  if (counterPartLink === null) {
    return false;
  }
  
  return counterPartLink;
}





    
